import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { news, addLike } from "api/news";
import "./News.scss";
import { useSelector } from "react-redux";
import InsLoader from "components/InsLoader/InsLoader";
import InsComments from "components/InsComments/InsComments";
import BrandArticlesItem from "components/Brands/BrandArticlesItem/BrandArticlesItem";
import FormationItem from "components/FormationItem/FormationItem";

const News = () => {
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const account = useSelector((state) => state.account);
  const [article, setarticle] = useState();
  const [loading, setloading] = useState(true);

  const getNews = () => {
    setloading(true);

    news(id)
      .then((data) => {
        setarticle(data);

        // I did not manage to make it work, even with an effect watching the article variable
        // I had to use a setTimeout to make it work instead, somehow the dom is not ready to process
        // Instagram embeds after the render with the article content
        setTimeout(() => {
          try {
            window.instgrm.Embeds.process();
          } catch (error) {
            console.log(error);
          }
        }, 1000);
      })
      .catch((err) => {
        goBack();
      })
      .finally(() => {
        setloading(false);
      });
  };

  const goBack = () => {
    history.replace("/");
  };

  const toggleLike = () => {
    addLike(id).then((data) => {
      setarticle({
        ...article,
        ...data,
      });
    });
  };

  useEffect(() => {
    getNews();
  }, [i18n.language]);

  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'viewport';
    meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=3, user-scalable=yes';
    document.head.appendChild(meta);

    return () => {
      document.head.removeChild(meta);
      const actualViewportMeta = document.createElement('meta');
      actualViewportMeta.name = 'viewport';
      actualViewportMeta.content = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no';
      document.head.appendChild(actualViewportMeta);
      setTimeout(() => {
        document.head.removeChild(actualViewportMeta);
      }, 200);
    };
  }, []);

  if (!article || loading) {
    return (
      <div className="page_wrapper">
        <InsLoader />
      </div>
    );
  }

  return (
    <div className="page_wrapper">
      <div className="news_wrapper">
        <div className="back_link_news" onClick={goBack}></div>
        <div className="news_likes">
          <div
            className={article.isLiked ? "like_icon liked" : "like_icon"}
            onClick={toggleLike}
          ></div>
          <div className="like_count">{article.likes}</div>
        </div>
        <div className="item_news_img_wrapper">
          <div
            className="item_news_img"
            style={{ backgroundImage: `url(${article.picture})` }}
          ></div>
        </div>
        <div className="article_content">
          <p className="content_brand">{article.brand}</p>
          <p className="content_title">{article.title}</p>
          <p className="content_subtitle">{article.subtitle}</p>
          <p className="main_separator"></p>
          <div className="content--bo">
            <div dangerouslySetInnerHTML={{ __html: article.content }} />
          </div>
        </div>
        <div className="article_footer">
          <div className="comments">
            <InsComments
              currentUserAvatar={account.picture}
              contentId={id}
              callApi="articles"
            />
          </div>
          {article.associated_article || article.associated_course ? (
            <p className="separator"></p>
          ) : null}
          <div className="cross">
            {article.associated_article.length > 0 && (
              <>
                <div className="title">{t("cross_univers")}</div>
                {article.associated_article.map((sideArticle) => (
                  <div key={sideArticle.id}>
                    <BrandArticlesItem
                      key={sideArticle.id}
                      id={sideArticle.id}
                      title={sideArticle.title}
                      subtitle={sideArticle.subtitle}
                      picture={sideArticle.picture}
                      content={sideArticle.content}
                      brandId={sideArticle.brand_id}
                    />
                  </div>
                ))}
              </>
            )}
            {article.associated_course.length > 0 && (
              <>
                <div className="title">{t("cross_course")}</div>
                {article.associated_course.map((course) => (
                  <div key={course.id}>
                    <FormationItem
                      brand={course.brand}
                      image={course.picture}
                      title={course.title}
                      formation={course.type}
                      time={course.time}
                      points={course.points}
                      idFormation={course.id}
                      pourcent={course.pourcent}
                    />
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default News;
